<template>
  <div id="app">
    {{ stateSync }}
    <router-view />
  </div>
</template>

<script>
import notification from "./utils/notification";
export default {
  mixins: [notification],
  created() {
    console.log("App created");
    var savedstate = localStorage.getItem("simpAdminState");
    if (savedstate != null) {
      this.$store.replaceState(JSON.parse(savedstate));
    }
  },
  // mounted() {
  //   this.registerNotifications();
  // },
  computed: {
    stateSync() {
      var stt = this.$store.state;
      localStorage.setItem("simpAdminState", JSON.stringify(stt));
      return "";
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  z-index: 0;
  position: relative;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
